import { Autocomplete, TextField } from "@mui/material";
import Disabled from "components/common/Disabled";
import { connect } from "react-redux";

export const IndustryClassElement = ({
  value,
  onChange,
  placeholder,
  industryClasses,
  loadingIndustryClasses,
}) => {
  const activeIndustryClasses =
    industryClasses?.filter(
      ({ key, isDeactivated }) => value === key || !isDeactivated
    ) ?? [];

  return (
    <Disabled ifReadOnly>
      <Autocomplete
        options={activeIndustryClasses}
        getOptionKey={({ key }) => key}
        getOptionLabel={({ name }) => name ?? ""}
        value={industryClasses.find((x) => x.key === value) ?? null}
        onChange={(_, value) => onChange(value?.key ?? null)}
        renderInput={(params) => (
          <TextField {...params} size={"small"} placeholder={placeholder} />
        )}
        disabled={loadingIndustryClasses}
      />
    </Disabled>
  );
};

const mapStateToProps = (state) => {
  return {
    industryClasses: state.temp.exposureMetrics?.industryClassChoices || [],
    loadingIndustryClasses: state.temp.exposureMetrics?.loadingIndustryClasses,
  };
};

export default connect(mapStateToProps)(IndustryClassElement);
